import classNames from 'classnames';

import Button from '../../../components/Button/Button';
import { StoresList } from './StoresList';
import { Breadcrumbs } from '../../../components/Breadcrumbs';
import Loading from '../../../components/Loading';
import { SearchBar } from './SearchBar';
import { useTranslation } from 'react-i18next';
import { useGetStores } from '../../../network';

export const StoresPage = () => {
    const { t } = useTranslation();

    const cn = classNames;
    const pages = [{ name: t('Stores'), path: '/chain/stores' }];

    const { data: { data: stores = [] } = {}, isLoading } = useGetStores();

    return (
        <>
            <Breadcrumbs pages={pages} />
            <div className="max-w-screen-lg flex flex-col lg:flex-row lg:justify-between items-start lg:items-center">
                <Button
                    type="link"
                    to="/chain/stores/create"
                    className="whitespace-nowrap h-9 inline-flex items-center rounded-lg border border-transparent bg-purple-500 px-14 py-1.5 text-sm font-bold text-white shadow-sm hover:bg-purple-600 focus:outline-none"
                >
                    {t('Add store')}
                </Button>

                {stores.length !== 0 && <SearchBar />}
            </div>
            <div
                className={cn({
                    'max-w-4xl': stores.length === 0,
                    'max-w-screen-lg': stores.length !== 0,
                })}
            >
                <Loading loading={isLoading}>
                    {stores.length === 0 ? (
                        <div className="mt-4 p-6 max-w-4xl bg-white rounded-xl shadow-lg flex flex-col">
                            <h3 className="text-lg font-bold text-black">{t('Create and Manage your Stores')}</h3>
                            <span className="mt-2 text-sm text-gray-800">{t('Welcome to your store manager. Here you will be able to create and manage all of your stores at every location')}</span>
                        </div>
                    ) : (
                        <div className="mt-4 p-6 max-w-screen-lg bg-white rounded-lg shadow-md flex flex-col">
                            <StoresList stores={stores} />
                        </div>
                    )}
                </Loading>
            </div>
        </>
    );
};
